import { DatePickerInput, type DatePickerInputProps } from "@mantine/dates";
import { DATE_FORMAT } from "constants/common/common";
import type { FC } from "react";

export type DateRangeValue = [Date | null, Date | null];

interface DateRangeInputProps
  extends Omit<DatePickerInputProps<"range">, "type" | "value" | "onChange"> {
  value?: DateRangeValue;
  onChange?: (value: DateRangeValue) => void;
}

const DateRangeInput: FC<DateRangeInputProps> = ({
  value = [null, null],
  onChange,
  placeholder = "Chọn khoảng thời gian",
  valueFormat = DATE_FORMAT,
  clearable = true,
  ...rest
}) => (
  <DatePickerInput
    type="range"
    // Mantine mặc định KHÔNG cho chọn cùng một ngày làm đầu và cuối khoảng.
    // Người dùng cần xem đúng một ngày (vd 29/8 → 0h đến 23:59:59) nên phải bật.
    // Phía tiêu thụ đã quy đổi startOf('day') / endOf('day') nên trọn ngày.
    allowSingleDateInRange
    value={value}
    onChange={(val) => onChange?.(val as DateRangeValue)}
    placeholder={placeholder}
    valueFormat={valueFormat}
    clearable={clearable}
    {...rest}
  />
);

export default DateRangeInput;
